<template>
  <div class="listbody">
    <scroll :data="searchListContent">
      <div>
        <city-item
          :search-list-content="searchListContent"
          @changeName="changeCity"
        />
      </div>
    </scroll>
  </div>
</template>

<script setup>
import Scroll from '../base/Scroll.vue';
import CityItem from '../base/CityItem.vue';

defineOptions({name: 'SearchList'});

defineProps({
  searchListContent: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['changeName']);

// 点击列表触发改变定位的事件
function changeCity (name) {
  emit('changeName', name);
}
</script>

<style lang="stylus" scoped>
.listbody
  width 100%
  height 100%
  background var(--page-bg)
  position absolute
  top 0
  right 0
  bottom 0
  left 0
  z-index 100
</style>
